module.exports = __webpack_public_path__ + "img/FR18869.5c58524a.png";